import { applyPatch } from 'fast-json-patch';
import { Operation } from 'fast-json-patch/module/core';

import { Injectable } from '@angular/core';

import {
  BaseWsService,
  ParsedWebsocketMessage,
  ResourcesService,
  ToastService,
  WebsocketMessageService,
} from '@mitsubishi/core';

import { ProjectFacade } from '../../state/project/project.facade';
import { APPLY_PATCH_TOPIC, ApplyPatchMessages } from './apply-patch.messages';

@Injectable({
  providedIn: 'root',
})
export class ApplyPatchWsService extends BaseWsService {
  constructor(
    wsMessageService: WebsocketMessageService,
    serverResourceService: ResourcesService,
    toastService: ToastService,
    private projectFacade: ProjectFacade
  ) {
    super(wsMessageService, serverResourceService, toastService);
  }

  subscribeTopic(projectId: string) {
    super.subscribeTopic(projectId);
  }

  protected get excludedMessagesFromLog(): string[] {
    return [];
  }

  protected setTopic(projectId: string) {
    this.topic = `${APPLY_PATCH_TOPIC}/${projectId}`;
  }

  protected handleMessage(message: ParsedWebsocketMessage) {
    super.handleMessage(message);

    const payload = message.payload;
    switch (message.description) {
      case ApplyPatchMessages.ApplyPatch: {
        const patch: ReadonlyArray<Operation> = JSON.parse(payload.patch);
        const currentProject = this.projectFacade.currentProject;
        try {
          const patchedProject = applyPatch(currentProject, patch, true, false);
          this.projectFacade.setProject(patchedProject.newDocument);
        } catch (error) {
          console.error('ERROR PATCH:', patch);
          console.log(error);
        }
        break;
      }
    }
  }
}
